import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet";
import Communication from "../../../Assets/image/background/front/Inverter_hover.webp";
import Tree from "../../../Assets/image/background/front/MOtor_HOVER.webp";
import Iot from "../../../Assets/image/background/front/keyboard_Hover.webp";
import Clock from "../../../Assets/image/background/front/controller.webp";
import "./FrontpageBanner.css";

function FrontPage() {
    const imageData = [Communication, Tree, Iot, Clock];
    const totalImages = imageData.length;

    // Clone first & last for infinite loop
    const extendedImages = [
        imageData[totalImages - 1],
        ...imageData,
        imageData[0],
    ];

    const [currentIndex, setCurrentIndex] = useState(1);
    const [isAnimating, setIsAnimating] = useState(true);

    /* ================= AUTO SLIDE ================= */
    useEffect(() => {
        let interval;

        const startInterval = () => {
            interval = setInterval(() => {
                setIsAnimating(true);
                setCurrentIndex((prev) => prev + 1);
            }, 10000);
        };

        const stopInterval = () => clearInterval(interval);

        const handleVisibilityChange = () => {
            document.hidden ? stopInterval() : startInterval();
        };

        startInterval();
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            stopInterval();
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    /* ================= LOOP RESET ================= */
    const handleTransitionEnd = () => {
        if (currentIndex === totalImages + 1) {
            setIsAnimating(false);
            setCurrentIndex(1);
        }

        if (currentIndex === 0) {
            setIsAnimating(false);
            setCurrentIndex(totalImages);
        }
    };

    /* ================= DOT CLICK ================= */
    const handleDotClick = (index) => {
        setIsAnimating(true);
        setCurrentIndex(index + 1);
    };

    const isLastVisibleSlide = currentIndex === totalImages;

    return (
        <>
            <Helmet>
                <title>Front Page Slider</title>
            </Helmet>

            <div className="frontpage-slider-wrapper">
                <div
                    className="slider-track"
                    style={{
                        transform: `translateX(-${currentIndex * 100}%)`,
                        transition: isAnimating
                            ? isLastVisibleSlide
                                ? "transform 5s cubic-bezier(0.16, 1, 0.3, 1)"
                                : "transform 3.8s cubic-bezier(0.22, 1, 0.36, 1)"
                            : "none",
                    }}
                    onTransitionEnd={handleTransitionEnd}
                >
                    {extendedImages.map((img, index) => (
                        <div className="slide" key={index}>
                            <img src={img} alt={`slide-${index}`} />
                        </div>
                    ))}
                </div>

                {/* DOTS */}
                <div className="slider-dots">
                    {imageData.map((_, index) => (
                        <button
                            key={index}
                            className={`dot ${currentIndex === index + 1 ? "dot-active" : ""
                                }`}
                            onClick={() => handleDotClick(index)}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

export default FrontPage;
